/**
 * Order sources
 *
 * @package HOPS
 * @subpackage Orders
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
const OrderSources = {

	Unknown: -1,

	Hops: 0,

	Local: 1,

	Pos: 2,

	Moto: 3,

	RecordedByOrg: 4,

	BalancingPayment: 5

};

export default OrderSources;
